import { useCallback, useRef } from 'react';

// Wraps an RTK Query `refetch` so it no-ops while the query is still uninitialized (e.g. skipped),
// instead of throwing "Cannot refetch a query that has not been started yet". The returned identity
// stays stable, so a refetch fired from a mount effect can't re-fire as a duplicate once the query starts.
export const useSafeRefetch = (refetch: VoidFunction, isUninitialized: boolean): VoidFunction => {
  const uninitializedRef = useRef(isUninitialized);
  uninitializedRef.current = isUninitialized;

  return useCallback(() => {
    if (uninitializedRef.current) return;
    try {
      refetch();
    } catch {
      // Query subscription not yet established in this mount cycle — RTK Query
      // will fetch automatically once the subscription is ready.
    }
  }, [refetch]);
};
